<!--  -->
<template>
 <div>
   <banner/>
    <crumbs/>
    <div class="contain">
     <swiper ref="swiperTop" class="swiper gallery-top" id="banner" :options="swiperOptionTop" >
        <swiper-slide class="slide-1 sli" v-for="item in nowArr" :key="item.id">
          <vue-photo-zoom-pro
            class="zoom"
            :out-zoomer="showType"
            :url="item.image"
            ></vue-photo-zoom-pro>
          <div class="imgdesc" v-if="item.description === undefined">暂无内容</div>
          <div class="imgdesc" v-else>{{item.description}}</div>

        </swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
    </swiper>
    <swiper ref="swiperThumbs" class="swiper gallery-thumbs"   id="banner2" :options="swiperOptionThumbs">
        <swiper-slide class="slide-1" v-for="item in nowArr" :key="item.id">
            <div class="imgbox">
                <img :src="item.image" alt="">
            </div>
        </swiper-slide>
    </swiper>

      <div class="currentIndex">
        <div class="pageState">
          <span class="cIndex">1</span>/<span class="sum">{{allNum}}</span>
        </div>
      </div>

 <el-pagination
  class="pagemodel1"
      @current-change="handleCurrentChange"
      :page-size="6"
      layout="total,prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <comment @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        <right-sidebar
          @pvcount="pvcount"
          :comment-count="commentTotal"
          :comment-gotop="commentOffsettop"
          :comment-show="isCommentshow"
          title="图片"
          :url="this.$route.fullPath"
          ref="rightSidebar"></right-sidebar>
        <go-top></go-top>
    </div>
 </div>
</template>

<script>
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import {getExhibitdetail} from '@/api/exhibit/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
let vm = null
export default {
  name: 'exhibitdetail',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    banner,
    swiper,
    swiperSlide,
    Comment,
    RightSidebar,
    goTop
  },
  data () {
    return {
      showType: true,
      // imgurl: 'https://t7.baidu.com/it/u=1951548898,3927145&fm=193&f=GIF',
      swiperOptionTop: {
        // loop: true,
        // loopAdditionalSlides: 100,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          init: function () {
            // let le = document.getElementsByClassName('sli').length
            // document.getElementsByClassName('sum')[0].innerHTML = le
          },
          slideChange: function () {
            let i = vm.$refs.swiperTop.$el.swiper.activeIndex
            console.log('i', i)
            document.getElementsByClassName('cIndex')[0].innerHTML = i + 1
          }
        }
      },
      swiperOptionThumbs: {
        centeredSlides: true,
        slideToClickedSlide: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        watchSlidesVisibility: true,
        watchSlidesProgress: true
      },
      dataList: [
        {
          image: 'https://t7.baidu.com/it/u=1951548898,3927145&fm=193&f=GIF'
        },
        {
          image: 'https://t7.baidu.com/it/u=1951548898,3927145&fm=193&f=GIF'
        }
      ],
      total: 0,
      newarr: [],
      nowArr: [],
      id: '',
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      allNum: 0
    }
  },
  updated () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$el.swiper
      const swiperThumbs = this.$refs.swiperThumbs.$el.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  created () {
    vm = this
    this.id = this.$route.query.id
    this.getImgs()
  },
  methods: {

    getImgs () {
      getExhibitdetail(this.id).then(res => {
        console.log(...res.data.data, 'mj')
        this.dataList = res.data.data
        this.total = this.dataList.length
        console.log(this.dataList, 'datalist')

        this.arrayChunk(this.dataList, 6)
      })
    },
    handleCurrentChange (val) {
      this.nowArr = []
      this.nowArr = this.newarr[val - 1]
      this.allNum = this.nowArr.length
      // document.getElementsByClassName('sum')[0].innerHTML = this.nowArr.length
      // console.log(this.nowArr, 'this')
    },
    arrayChunk: function (arr, n) {
      while (arr.length) {
        this.newarr.push(arr.splice(0, n))
      }
      this.nowArr = this.newarr[0]
      this.allNum = this.nowArr.length
      // document.getElementsByClassName('sum')[0].innerHTML = this.nowArr.length
    },
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    fontsizeType (val) {
      this.fontsizetype = val
    },
    /* 浏览量 */
    pvcount (val) {
      this.pv = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/exhibit.scss';
.zoom{
  &>>>.img-out-show{
  //  position: fixed !important;
  transform: translate(0%);
  }
}

</style>



// WEBPACK FOOTER //
// src/view/exhibit/detail.vue